/* global jQuery */

/*
Det toggle element der skal wrapper, skal have classen .slide-toggle-wrapper.
Det element (knappen) der skal klikkes på, skal have classen .slide-toggle-button.
Det element der skal skjules og vises, skal have classen .slide-toggle-content.
Det er muligt at ændre på breakpointet ved at sætte attributen data-slide-toggle-breakpoint="" på wrapper elementet.
Det er muligt at ændre på duration ved at sætte attributen data-slide-toggle-duration="" på wrapper elementet.
 */

export default function SlideToggle() {
  jQuery('body').ready(setup)
}

function setup() {
  let hasClicked = false
  jQuery('.slide-toggle-wrapper').on('click', '.slide-toggle-button', (e)=>{
    const WRAPPER_ELEMENT = jQuery(e.target).closest('.slide-toggle-wrapper')

    let screenWidth = window.innerWidth
    let breakPoint = WRAPPER_ELEMENT.attr('data-slide-toggle-breakpoint') ?? null
    let duration = WRAPPER_ELEMENT.attr('data-slide-toggle-duration') ?? 400
    let contentClass = '.slide-toggle-content' // CSS Selector for the element to toggle on and off

    if (breakPoint !== null && screenWidth > parseInt(breakPoint)) {
      return
    }

    e.preventDefault()

    const CONTENT_ELEMENT = WRAPPER_ELEMENT.find(contentClass)

    if (hasClicked) {
      return
    }

    let isOpen = CONTENT_ELEMENT.is(':visible')
    WRAPPER_ELEMENT.toggleClass('open', !isOpen)

    CONTENT_ELEMENT.slideToggle(parseInt(duration))

    hasClicked = true
    setTimeout(() => { hasClicked = false }, duration)
  })
}